import { Component, computed, Input, OnInit } from '@angular/core';
import { Employee, TripDetails } from './trip.model';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/trip-view/services/common.service';
import { CommonCabService } from 'src/app/trip-view-cab/services/common-cab.service';
import { tripDetailsMockData } from './cab-trip-stop-timeline-mock-data';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
import { DataService } from 'src/app/data.service';
import { DateUtils } from 'src/app/utils/days-utils';
import * as dayjs from 'dayjs';
import { ToastService } from 'mis-crystal-design-system/toast';
import { ATTENDANCE_ACTIONS, AttendanceAction } from 'src/app/utils/constants';
export enum TripStatus {
  NotStarted,
  InProgress,
  Completed,
  Delayed,
  OnTime
}

@Component({
  selector: 'cab-trip-stop-timeline',
  templateUrl: './cab-trip-stop-timeline.component.html',
  styleUrls: ['./cab-trip-stop-timeline.component.scss']
})
export class CabStopTripTimelineComponent implements OnInit {
  @Input() tripDetails?: TripDetails;
  IMAGE_CONSTANTS:any = {};
  employeeInfo = false;
  employeeDetailsInfo;
  firstLogoutInProgress = false;
  isCabAlreadyInProgress = 0;
  carIconDisplayed = false; // New flag to track car icon display
  greenColor:string = '#547F40'
  redColor:string = '#B00020';
  isAllowSignoutEmployeesOnTripView=computed(()=>this.dataService.isAllowSignoutEmployeesOnTripView());
  AttendanceAction=AttendanceAction;

  constructor(private dateFormatter:DatePipe, private commonService:CommonService, private commonCabService:CommonCabService, private envService:EnvironmentService, public dataService:DataService,private toast:ToastService) {
    this.setImagePaths();
  }

  ngOnInit(): void { }

  setImagePaths(): void {
    const basePath = this.envService.getImgSrc()
    
    this.IMAGE_CONSTANTS.MALE_ICON = `${basePath}assets/icons/male_icon.svg`;
    this.IMAGE_CONSTANTS.FEMALE_ICON = `${basePath}assets/icons/female_icon.svg`;
    this.IMAGE_CONSTANTS.ESCORT_ICON = `${basePath}assets/icons/escort_icon.svg`;
    this.IMAGE_CONSTANTS.LOCATION_ICON = `${basePath}assets/icons/location_icon.svg`;
    this.IMAGE_CONSTANTS.INFO_ICON = `${basePath}assets/icons/info_icon.svg`;
    this.IMAGE_CONSTANTS.CAR_ICON = `${basePath}assets/icons/car_icon.svg`;
    this.IMAGE_CONSTANTS.TIMELINE_ICON = `${basePath}assets/icons/timeline_icon.svg`;
    this.IMAGE_CONSTANTS.DESTINATION_ICON = `${basePath}assets/icons/destination_icon.svg`;
    this.IMAGE_CONSTANTS.SOURCE_ICON = `${basePath}assets/icons/source_icon.svg`;
    this.IMAGE_CONSTANTS.PLANNED_TIME_ICON = `${basePath}assets/icons/planned_time_icon.svg`;
    this.IMAGE_CONSTANTS.DRIVER_ARRIVAL_ICON = `${basePath}assets/icons/driver_arrival_icon.svg`;
    this.IMAGE_CONSTANTS.ACTUAL_TIME_ICON = `${basePath}assets/icons/actual_time_icon.svg`;
    this.IMAGE_CONSTANTS.DOT_SEPARATOR = `${basePath}assets/icons/dot_separator.svg`;
    this.IMAGE_CONSTANTS.LINE_SVG = `${basePath}assets/icons/Line.svg`;
    this.IMAGE_CONSTANTS.CALL_ICON = `${basePath}assets/icons/call.svg`;
    this.IMAGE_CONSTANTS.SPECIAL_NEED_TYPE_ICON = `${basePath}assets/icons/special_need_type_icon.svg`;
    this.IMAGE_CONSTANTS.BLUE_INFO_ICON = `${basePath}assets/icons/blue_info_icon.svg`;
    this.IMAGE_CONSTANTS.NO_SHOW_ICON = `${basePath}assets/icons/no_show_icon.svg`;
    this.IMAGE_CONSTANTS.SIGN_OUT_ICON = `${basePath}assets/icons/signout-action.svg`;
    this.IMAGE_CONSTANTS.SIGN_IN_ICON = `${basePath}assets/icons/signin-action.svg`;
  }

  hoveredTooltipIndex: number | null = null;
  tooltip_text:string = `Vehicle reached the employee's geofence by 10:20, slowing to under 5 km/h `
  showTooltip(index: number) {
    this.hoveredTooltipIndex = index;
  }
  
  hideTooltip(index: number) {
    if (this.hoveredTooltipIndex === index) {
      this.hoveredTooltipIndex = null;
    }
  }
  

  getTooltipText(value: string): string {
    return value;
  }

  getTimeDifference(emp:any): any {
    if(emp['noShow']){
      return 0;
    }
    if(!emp['actualPickupTime'] || !emp['actualDropTime'] || !emp['plannedDropTime']){
      return 0;
    }
    const timeDifference = ( emp['actualDropTime'] - emp['plannedDropTime'])/60000;
    if (Number.isInteger(timeDifference)) {
      return timeDifference;
    }
    return Math.trunc(timeDifference);
  }

  getFinalTimeDifference(actualEndTime:any, plannedEndTime:any): any {
    const timeDifference = ( actualEndTime - plannedEndTime)/60000;
    if (Number.isInteger(timeDifference)) {
      return timeDifference;
    }
    return Math.trunc(timeDifference);
  }

  getTripStatus(employee: Employee, index: number): TripStatus {
    const nextEmployee = this.tripDetails.employees[index + 1];
    const isOutDirection = this.tripDetails['direction'] === 'OUT';

    if (index === 0) {
      if (isOutDirection) {
        if (this.tripDetails.employees.length === 1) {
          if(employee.noShow){
            return TripStatus.Completed;
          }
          if(!employee.actualPickupTime || !employee.actualDropTime){
            this.firstLogoutInProgress = true;
            return TripStatus.NotStarted;
          }
          if(employee.actualPickupTime && employee.actualDropTime){
            return TripStatus.Completed;
          }
          this.firstLogoutInProgress = true;
          return TripStatus.InProgress;
        }
        if ((employee.actualPickupTime && employee.actualDropTime) || employee.noShow) {
          if (nextEmployee && nextEmployee.noShow) {
            return TripStatus.Completed;
          }
          if (nextEmployee && !(nextEmployee.actualDropTime)) {
            return TripStatus.InProgress;
          }
          return TripStatus.Completed;
        }
        if (employee.noShow){
          return TripStatus.Completed;
        }
        if (!employee.actualPickupTime && !employee.noShow){
          this.firstLogoutInProgress = true;
          return TripStatus.NotStarted;
        }
      } else {
        if(employee.noShow){
          return TripStatus.Completed;
        }
        if (this.tripDetails.employees.length === 1 && employee.actualPickupTime && this.tripDetails['status'] !== 'Ended') {
          return TripStatus.InProgress;
        }
        if (this.tripDetails.employees.length === 1 && employee.actualPickupTime && this.tripDetails['status'] === 'Ended') {
          return TripStatus.Completed;
        }
        if (employee.actualPickupTime && (this.tripDetails.employees[index + 1]?.actualPickupTime || this.tripDetails.employees[index + 1]?.noShow)) {
          return TripStatus.Completed;
        }
        if (employee.actualPickupTime && !this.tripDetails.employees[index + 1]?.actualPickupTime) {
          return TripStatus.InProgress;
        }
        return TripStatus.NotStarted;
      }
    }

    if (index === this.tripDetails.employees.length - 1) {
      if (isOutDirection) {
        if(employee.noShow && this.tripDetails.status !== 'Ended'){
          return TripStatus.NotStarted;
        }
        if(employee.noShow && this.tripDetails.status === 'Ended'){
          return TripStatus.Completed;
        }
        if (employee.actualDropTime && this.tripDetails.status === 'Ended') {
          return TripStatus.Completed;
        }
        if (employee.actualDropTime && this.tripDetails.status !== 'Ended') {
          return TripStatus.NotStarted;
        }
        return TripStatus.NotStarted;
      } else {
        if(employee.noShow && this.tripDetails.status !== 'Ended'){
          return TripStatus.InProgress;
        }
        if(employee.noShow && this.tripDetails.status === 'Ended'){
          return TripStatus.Completed;
        }
        if (employee.actualPickupTime && this.tripDetails.status === 'Ended') {
          return TripStatus.Completed;
        }
        if (employee.actualPickupTime && this.tripDetails.status !== 'Ended') {
          return TripStatus.InProgress;
        }
        return TripStatus.NotStarted;
      }
    }

    if (isOutDirection) {
      if(employee.noShow && nextEmployee && (nextEmployee.noShow || nextEmployee.actualDropTime)){
        return TripStatus.Completed;
      }
      if(employee.noShow && nextEmployee && (!nextEmployee.noShow || !nextEmployee.actualDropTime)){
        return TripStatus.InProgress;
      }
      if (employee.actualDropTime && nextEmployee && (nextEmployee.noShow || nextEmployee.actualDropTime)) {
        return TripStatus.Completed;
      }
      if (employee.actualDropTime && nextEmployee && !(nextEmployee.noShow || nextEmployee.actualDropTime)) {
        return TripStatus.InProgress;
      }
      return TripStatus.NotStarted;
    } else {
      if(employee.noShow && nextEmployee && (nextEmployee.noShow || nextEmployee.actualPickupTime)){
        return TripStatus.Completed;
      }
      if(employee.noShow && nextEmployee && (!nextEmployee.noShow || !nextEmployee.actualPickupTime)){
        return TripStatus.InProgress;
      }
      if (employee.actualPickupTime && nextEmployee && (nextEmployee.noShow || nextEmployee.actualPickupTime)) {
        return TripStatus.Completed;
      }
      if (employee.actualPickupTime && nextEmployee && !(nextEmployee.noShow || nextEmployee.actualPickupTime)) {
        return TripStatus.InProgress;
      }
      return TripStatus.NotStarted;
    }
  }

  sortEmployees(arr: Employee[]): Employee[] {
    const sortedArr = arr.sort((a, b) => {
      if (a.actualPickupTime !== 0 && b.actualPickupTime !== 0) {
        return b.actualDropTime - a.actualDropTime;
      } else if (a.actualPickupTime === 0 && b.actualPickupTime !== 0) {
        return 1;
      } else if (a.actualPickupTime !== 0 && b.actualPickupTime === 0) {
        return -1;
      } else {
        return 0;
      }
    });
    return sortedArr;
  }

  getTooltipMessage(emp:any){
    return 'Destination Reach Time';
  }

  getStatusClass(employee: Employee, index: number): string {
    const status = this.getTripStatus(employee, index);
    if (status === TripStatus.Completed) {
      return 'completed';
    } else if (status === TripStatus.InProgress) {
      return 'in-progress';
    } else {
      return 'not-started';
    }
  }

  showSvg(status: TripStatus): boolean {
    return status === TripStatus.InProgress;
  }

  shouldShowCarIcon(status: TripStatus): boolean {
    if (status === TripStatus.InProgress && !this.carIconDisplayed) {
      // this.carIconDisplayed = true;
      return true;
    }
    return false;
  }
  
  getFillColor(status: TripStatus): string {
    switch (status) {
      case TripStatus.Completed:
        return '#638FE7';
      case TripStatus.InProgress:
        return '#FF9D00';
      case TripStatus.NotStarted:
        return '#E0E0E0';
      default:
        return '#E0E0E0';
    }
  }

  getBoardingStatus(emp: any) {
    if (emp['noShow']) {
      return 'NO SHOW';
    }
    const isLoggedInTrip = this.tripDetails['direction'] === 'IN';
    const employeePickedUp = emp['actualPickupTime'];
    const employeeDropped = emp['actualDropTime'];
    if (isLoggedInTrip) {
      return employeePickedUp ? 'BOARDED' : '';
    }
    if(!isLoggedInTrip){
      return employeeDropped ? 'DROPPED' : '';
    }
    return '';
  }

  getDropLocation(status:string, employee :any){
    return status === 'OUT' ? employee?.plannedDropLocation?.address : employee?.plannedPickupLocation?.address;
  }

  openEmployeeDetails(emp) {
    if (!!emp?.name) {
      this.employeeInfo = true;
      this.employeeDetailsInfo = emp;
    }
  }

  getTripCurrentStatus(): string {
    const tripStatus = this.tripDetails?.status;
    const actualEndTime = this.tripDetails?.actualEndTime;
    let plannedEndTime = this.tripDetails?.employees[this.tripDetails?.employees.length - 1]?.plannedDropTime;
    if(this.tripDetails['direction'] === 'OUT'){
      plannedEndTime = this.tripDetails?.employees[this.tripDetails?.employees.length - 1]?.plannedDropTime;
    }
    return tripStatus === 'Ended'
      ? `ENDED AT: ${this.formatTime(actualEndTime)}`
      : `TRIP ENDS AT : ${this.formatTime(plannedEndTime)}`;
  }

  isPositive(value: number): boolean {
    return value > 0;
  }

  getEmployeeTimings(time: number): string {
    return time ? this.formatTime(time) : '--:--';
  }

  getDestinationReachTime(emp){
    return emp.actualDropTime ? 
          this.formatTime(emp.actualDropTime):
          emp.plannedDropTime ? 
          this.formatTime(emp.plannedDropTime):
          '--:--'
  }

  getDestinationTooltipMessage(emp){
    return emp.actualDropTime ? 
          `Destination React time`:
          `Planned Reach time`
  }

  formatTime(time: number): string {
    const timeZone = this.commonService.timeZone || 'Asia/Kolkata';
    return DateUtils.formatTimeWithZone(time, timeZone, 'HH:mm');
  }

  isSignedIn(emp: any): boolean {
    const tripStatus = this.tripDetails?.status;
    return !!emp['actualPickupTime']  && !emp['actualDropTime'] && tripStatus !== 'Ended'  ;
  }

  updateEmployeeStatus(emp: any,action:AttendanceAction): void {
    const tripId = this.commonService.tripId;
    const actionConfig = ATTENDANCE_ACTIONS[action];
    const payload={
      buid:this.commonService.buid,
      employeeGuid:emp.empGuid,
      eventTimestamp: dayjs().valueOf(),
      locationTimestamp:dayjs().valueOf(),
      employeeAppAttendanceSource:"TRIP_CARD_BUTTON",
      employeeAppAttendanceEventType:action,
      vehicleGuid:this.tripDetails?.['vehicle']?.['vehicleGuid'],
      tripId:tripId,
      isSignedOff:actionConfig.isSignedOff
    }

    this.commonService.updateAttendance(payload).subscribe({
      next: (response) => {
       this.toast.displayMsg(`Employee ${emp?.name} ${actionConfig.successText} Successfully !`);
       setTimeout(() => {
        window.location.reload();
       }, 2000);
      },
      error: (error) => {
        this.toast.displayMsg(`Error In ${actionConfig.errorText} Employee ${emp?.name}`);
      }
    });
  }
}
